import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { UserProfile } from '@teetsh/app/src/types/user';

interface UpdateOnboardingFieldsParams {
  dashboard?: boolean;
  edtList?: boolean;
  edt?: boolean;
  eleves?: boolean;
  checklistDisabled?: boolean;
}

async function updateOnboardingFields(
  params: UpdateOnboardingFieldsParams,
): Promise<UserProfile> {
  const response = await request('/user/onboarding/fields', {
    method: 'PATCH',
    body: params,
  });
  return response;
}

export function useUpdateOnboardingFields() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateOnboardingFields,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['user'] });
    },
  });
}
